/** Maps "search by <key>" + value to the `id` / `name` list params (only the selected key is sent). */
export const toSearchParams = (searchKey: string, searchValue: string) => ({
  id: searchKey === 'id' ? searchValue : '',
  name: searchKey === 'name' ? searchValue : '',
});
